module.exports = __webpack_public_path__ + "assets/images/key/key_lon_syd_2020.svg?v=f7610a08";